import { z } from 'zod';

export const buslineSchema = z.object({
  company: z.object({
    label: z.string(),
    value: z.number(),
  }),
  name: z.string().min(1),
  code: z.string().min(1),
  fleet: z.object({
    label: z.string(),
    value: z.number(),
  }),
  checkList: z
    .object({
      label: z.string(),
      value: z.number(),
    })
    .nullish(),
  driver: z
    .object({
      label: z.string(),
      value: z.string(),
    })
    .optional(),
  startAt: z.date(),
  endAt: z.date(),
  daysOfWeek: z
    .array(z.enum(['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']))
    .optional()
    .transform((value) => value || []),

  lineStrings: z
    .array(
      z.object({
        type: z.literal('LineString'),
        coordinates: z.array(z.array(z.number())),
      }),
    )
    .optional(),

  lineStringSelected: z
    .object({
      label: z.string(),
      value: z.coerce.number(),
    })
    .optional(),
});

export type IBuslineSchema = z.infer<typeof buslineSchema>;
